import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=0bb4a329"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"
import style0 from "./NewProducts.vue?vue&type=style&index=0&id=0bb4a329&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports